<div class="dev-token-page">
  <div class="dev-token-card">
    <h1 class="dev-token-title">Token Clerk de développement</h1>

    <p class="dev-token-help">
      Template <code>{{ template }}</code>. Cliquez sur le token pour le copier (sans « Bearer »),
      puis utilisez-le dans l'en-tête <code>Authorization: Bearer &lt;token&gt;</code>.
    </p>

    @if (loading()) {
      <p class="dev-token-status">Récupération du token…</p>
    } @else if (token()) {
      <button
        type="button"
        class="dev-token-value"
        title="Cliquer pour copier"
        (click)="copyToken()"
      >
        {{ token() }}
      </button>

      <p class="dev-token-status" aria-live="polite">
        {{ copied() ? 'Token copié dans le presse-papiers.' : 'Cliquez sur le token pour le copier.' }}
      </p>
    }

    @if (error()) {
      <p class="dev-token-error" role="alert">{{ error() }}</p>
    }

    <div class="dev-token-actions">
      <button type="button" class="btn btn-primary" [disabled]="loading()" (click)="loadToken()">
        Régénérer
      </button>
      <a routerLink="/" class="btn btn-secondary">Retour à l'accueil</a>
    </div>
  </div>
</div>
